import { useEffect, useState } from 'react';

export default (el: HTMLElement | null, options?: IntersectionObserverInit) => {
  const [isVisible, setIsVisible] = useState(false);
  const callback = ([entry]: any) => {
    setIsVisible(entry.isIntersecting);
  };

  useEffect(() => {
    const watch = new IntersectionObserver(callback, options);
    if (el) {
      watch.observe(el);
      return () => watch.unobserve(el);
    }
    return undefined;
  }, [el]);

  return isVisible && !!el;
};
